import { REG_EX } from '@/utils/address';

export const addressFormSchema = {
	nickName: {
		required: true,
		maxLength: 30,
		pattern: REG_EX.NICKNAME_ALPHA_NUMERIC_SPECIAL_CHAR.source,
	},
	street: {
		required: true,
		maxLength: 99,
		pattern: REG_EX.SPANISH_ALPHA_NUMERIC.source,
	},
	exteriorNumber: {
		required: true,
		maxLength: 9,
		pattern: REG_EX.NUMERIC.source,
	},
	addressIndications: {
		required: false,
		maxLength: 49,
		pattern: REG_EX.SPANISH_ALPHA_NUMERIC.source,
	},
	zipCode: {
		required: true,
		maxLength: 5,
		pattern: REG_EX.NUMERIC.source,
	},
	colony: {
		required: true,
	},
	colonyNotFound: {
		required: true,
		maxLength: 128,
		pattern: REG_EX.ALPHA_NUMERIC_SPECIAL_CHAR.source,
	},
	municipality: {
		maxLength: 40,
		required: true,
	},
	firstName: {
		required: true,
	},
	lastName: {
		required: true,
	},
};
